<template>
  <p class="search-experience-note" :class="noteClass">
    <span>{{ message }}</span>
    <button type="button" class="search-experience-note-link" v-on:click="$emit('switch')">{{ action }}</button>
  </p>
</template>

<script>
export default {
  name: "SearchExperienceBanner",
  props: {
    mode: {
      type: String,
      default: "unified"
    },
    align: {
      type: String,
      default: "page"
    }
  },
  computed: {
    noteClass() {
      const classes = []
      if (this.align === "header") {
        classes.push("search-experience-note-header")
      } else {
        classes.push("search-experience-note-page")
      }
      if (this.mode === "classic") {
        classes.push("search-experience-note-classic")
      }
      return classes
    },
    message() {
      if (this.mode === "classic") {
        return "This is the previous search."
      }
      return "This is the new search."
    },
    action() {
      if (this.mode === "classic") {
        return "Switch to the new search"
      }
      return "Switch back to the old version"
    }
  }
}
</script>

<style lang="scss" scoped>
.search-experience-note {
  box-sizing: border-box;
  margin: 0;
  color: #3d3d3d;
  line-height: 1.45;
}

.search-experience-note-page {
  display: block;
  width: 100%;
  margin: 0 0 12px;
  padding: 0;
  text-align: right;
  font-size: 14px;
}

.search-experience-note-header {
  display: block;
  margin: 0;
  padding: 0;
  text-align: right;
  font-size: 14px;
}

.search-experience-note-classic {
  padding-right: 24px;
}

.search-experience-note-link {
  appearance: none;
  background: none;
  border: 0;
  padding: 0;
  margin-left: 8px;
  color: #101b23;
  font: inherit;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}

.search-experience-note-link:hover {
  color: #000;
}

.search-experience-note-link:focus {
  outline: 2px solid #101b23;
  outline-offset: 2px;
}
</style>
